// extracted by mini-css-extract-plugin
export default {"jobsToBeDone":"jobsToBeDone--hfG-n","jobsToBeDoneCards":"jobsToBeDoneCards--hinSA"};